import { type SchedulingTeamAttributes } from './generated/SchedulingTeamAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import ColorAttribute, {
  type IColorAttribute,
} from './concerns/ColorAttribute';

interface SchedulingTeam extends SchedulingTeamAttributes, IColorAttribute {}

@model
@ColorAttribute()
class SchedulingTeam extends ApplicationModel {
  // Start auto-generated
  static typename: 'SchedulingTeam' = 'SchedulingTeam';
  get typename(): 'SchedulingTeam' {
    return 'SchedulingTeam';
  }

  static internalTypename: 'Scheduling::Team' = 'Scheduling::Team';
  get internalTypename(): 'Scheduling::Team' {
    return 'Scheduling::Team';
  }

  static fields = {
    color: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    developTeamId: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    projectId: attr({ readable: true }),
    teamMembersCount: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    createdByUser: attr.belongsTo({ readable: true, typename: 'User' }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    developTeam: attr.belongsTo({ readable: true, typename: 'Project' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    screenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
    customFieldValues: attr.hasMany({
      args: { ids: '[ID!]', keys: '[String!]' },
      readable: true,
    }),
    teamMembers: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default SchedulingTeam;
